module.exports = __webpack_public_path__ + "img/powered by 8th wall_horizontal_white.e6bfe03c.png";